import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getRuntimeEnvVariables } from '../../helpers/Utils';
import './Label.scss';
import Small from './Small';

const market = process.env.RAZZLE_MARKET;

const Label = (props) => {
  const {
    featured,
    popular,
    timeLimited,
    timeLimitedCount,
    exclusive,
    bestValue,
    welcomeGift,
    children,
    type,
    inlineSpacing,
  } = props;

  // Apply change color for: Mortgage, Insurance, SA of moneyHero
  const colorType = getRuntimeEnvVariables('RUNTIME_BRAND_REFRESHING') !== 'true'
      || market !== 'moneyhero'
      ? type
      : `mh-${type}`;

  const classes = classNames({
    label: true,
    featured,
    popular,
    'time-limited': timeLimited,
    'time-limited-count': timeLimitedCount,
    exclusive,
    'best-value': bestValue,
    'welcome-gift': welcomeGift,
    [colorType]: colorType,
    'inline-spacing': inlineSpacing,
  });

  return (
    <Small bold className={classes}>
      { children }
    </Small>
  );
};

Label.defaultProps = {
  featured: false,
  popular: false,
  timeLimited: false,
  timeLimitedCount: false,
  exclusive: false,
  bestValue: false,
  welcomeGift: false,
  type: null,
  children: null,
  inlineSpacing: false,
};

Label.propTypes = {

  /** Style featured */
  featured: PropTypes.bool,

  /** Style popular */
  popular: PropTypes.bool,

  /** Style timeLimited */
  timeLimited: PropTypes.bool,

  /** Style timeLimitedCount */
  timeLimitedCount: PropTypes.bool,

  /** Style exclusive */
  exclusive: PropTypes.bool,

  /** Style bestValue */
  bestValue: PropTypes.bool,

  /** Style welcomeGift */
  welcomeGift: PropTypes.bool,
  type: PropTypes.string,
  children: PropTypes.node,
  inlineSpacing: PropTypes.bool,
};

export default Label;
